import gql from 'graphql-tag';

export default gql`
  fragment prospectCustomizeItemDateFragment on ProspectCustomizeItemDate {
    id
    value
    poolProspectCustomizeItemId
  }
`;
